import { Form, Button as ButtonAD } from 'antd';
import cs from 'classnames';
import type React from 'react';
import { useTranslation } from 'react-i18next';

type ItemP = React.ComponentProps<typeof Form.Item>;

type ButtonP = Omit<React.ComponentProps<typeof ButtonAD>, 'css'> & {
  title?: string;
  fullWidth?: boolean;
};

type P = {
  item?: ItemP;
  button?: ButtonP;
};

const defaultButtonProperties: ButtonP = {};

const Button: React.FC<P> = ({ item, button: { fullWidth = false, ...button } = defaultButtonProperties, ...rest }) => {
  const { t } = useTranslation();

  return (
    <Form.Item {...item}>
      <ButtonAD
        className={cs('form__button', {
          'form__button--full-width': fullWidth,
        })}
        type="primary"
        htmlType="submit"
        {...button}
        {...rest}
      >
        {t(button?.title ?? 'Submit')}
      </ButtonAD>
    </Form.Item>
  );
};

export default Button;
